window.ContentCard = phrase => {
	return {
		val: phrase,
	};
};
